import { post, get } from '../../../utils/api';
import { withUnauthorizedToken } from '../../../utils/auth';

export default {
  getList: () => get({ url: 'stock/list' }),
  apply: params => post({ url: 'stock/apply', data: withUnauthorizedToken({ ...params }) }),
  applyExtra: params =>
    post({ url: 'stock/apply-extra', data: withUnauthorizedToken({ ...params }) }),
  clear: () => post({ url: 'stock/clear', data: withUnauthorizedToken() }),
  unconditionalList: () => get({ url: 'stock/unconditional-list', data: withUnauthorizedToken() }),
};
